import React from 'react';
import numeral from 'numeral';

import getSize from "../../../../utils/getSize";
import NHTable from '../../../common/NHTable';

import css from './index.css';

/**
 * 新生报到统计
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-08-16
 * Version: 1.0
 * Modify log:
 */
class XsbdtjComponent extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        const columnConst = [
            {
                title: '序号',
                width: '50px',
                dataIndex: 'ROW_ID',
            }, {
                title: '学生类别',
                width: '70px',
                dataIndex: 'XSLB',
                searchType:"select"
                // commonSearch: false
            }, {
                title: '总人数',
                width: '120px',
                dataIndex: 'ZRS',
                commonSearch: false,
                searchType:"input"
            }, {
                title: '已报到',
                width: '120px',
                dataIndex: 'YBD',
                commonSearch: false,
                searchType:"input"
            }, {
                title: '未报到',
                width: '120px',
                dataIndex: 'WBD',
                commonSearch: false,
                searchType:"input"
            }, {
                title: '报到率',
                width: '120px',
                dataIndex: 'BDL',
                commonSearch: false,
                render: (value, row, index) => {
                    return numeral(value * 100).format("0.00") + '%';
                },
                searchType:"input"
            }
        ];

        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 220}}>
                <div style={{width: '100%', height: '90%',}}>
                    <NHTable ref='nhTable'
                             rowKey={record => record.ROW_ID}
                             sign={"zhxg_yxxt_tjcx_bdtj_xsbdtj"}
                             columns={columnConst}>
                    </NHTable>
                </div>
            </div>
        )
    }

}

export default XsbdtjComponent;


// WEBPACK FOOTER //
// ./components/tjcx/bdtjcx/jxBdtjcx/xsbdtj.js